import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { TEXT_ANNOTATION_TYPE } from 'src/data/annotation';
import { GENERATION_TOOL } from 'src/data/generationTool';
import { Loader } from '../Loader';
import { Annotation } from '../Annotation';
import { addIdToAnnotationsItems } from './utils';
import { useStyles } from './useStyles';

export const MainAnnotations = ({
  className,
  annotations,
  loading,
  displayInteractive,
  onUseAnnotationEntry,
  generationTool,
}) => {
  const styles = useStyles();

  const mappedItems = useMemo(() => addIdToAnnotationsItems(annotations), [annotations]);

  return (
    <div className={cx(styles.root, className)}>
      {loading ? (
        <Loader className={styles.loader} />
      ) : (
        mappedItems.map(({ type, value }) => (
          <Annotation
            className={styles.annotation}
            key={type}
            type={type}
            values={value}
            interactive={displayInteractive}
            onUseEntry={onUseAnnotationEntry}
            generationTool={generationTool}
          />
        ))
      )}
    </div>
  );
};

MainAnnotations.propTypes = {
  className: PropTypes.string,
  annotations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(Object.values(TEXT_ANNOTATION_TYPE)),
      value: PropTypes.arrayOf(PropTypes.oneOf([PropTypes.string, PropTypes.shape()])),
    })
  ).isRequired,
  loading: PropTypes.bool,
  displayInteractive: PropTypes.bool,
  onUseAnnotationEntry: PropTypes.func,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
};

MainAnnotations.defaultProps = {
  className: null,
  loading: false,
  displayInteractive: false,
  onUseAnnotationEntry: null,
  generationTool: null,
};
